/**
 * @fileoverview AipAssistSidebarShell — dark-mode outer container for the
 * AIP Assist chat panel, sized to fit Foundry's right resizable sidebar.
 * Composes three slots: a fixed header, a scrollable body (the conversation
 * stream + suggestions), and a fixed footer (the prompt input row).
 *
 * Foundry mapping: `aip-assist-impl__assist-container bp6-dark` →
 * `__header` / `__chat` / `__footer-border` + `__footer`. We mirror the
 * separator border with a `<div class="bp-aip-assist-footer-border" />`.
 */

import type { ReactElement, ReactNode } from "react";

interface Props {
  header: ReactNode;
  children: ReactNode;
  footer: ReactNode;
  className?: string;
}

export function AipAssistSidebarShell({
  header,
  children,
  footer,
  className,
}: Props): ReactElement {
  return (
    <div data-testid="aip-assist-sidebar-shell" className={["bp-aip-assist-sidebar bp6-dark", className].filter(Boolean).join(" ")}>
      {header}
      <div className="bp-aip-assist-body">{children}</div>
      <div className="bp-aip-assist-footer-border" />
      <div className="bp-aip-assist-footer">{footer}</div>
    </div>
  );
}
